import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  role: "region",
  "aria-label": "Become a creator values"
}
const _hoisted_2 = { class: "_flexcol _gap-6" }
const _hoisted_3 = {
  class: "_grid _grid-cols-2 _grid-cols-4--m _tac _jc-c _gap-4 _gap--6--m",
  role: "list"
}
const _hoisted_4 = {
  key: 0,
  class: "_tac _mt-2"
}
const _hoisted_5 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_become_a_creator_values_title = _resolveComponent("become-a-creator-values-title")
  const _component_values_section_item = _resolveComponent("values-section-item")
  const _component_become_a_creator_stats = _resolveComponent("become-a-creator-stats")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_box, { huge: "" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_become_a_creator_values_title),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.benefits, (value) => {
              return (_openBlock(), _createBlock(_component_values_section_item, _mergeProps({
                key: value.title
              }, { ref_for: true }, value, { role: "listitem" }), null, 16 /* FULL_PROPS */))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          (_ctx.$displayMode.isWeb)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("a", {
                  href: $props.becomeACreatorUrl,
                  class: "gfu-btn gfu-btn--primary gfu-btn--soft _ttu"
                }, _toDisplayString(_ctx.Resources.Homepage.BecomeACreatorButton), 9 /* TEXT, PROPS */, _hoisted_5)
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_become_a_creator_stats, _mergeProps($props.creatorStatistics, {
            layout: "extranarrow",
            class: "_bt-1 _bc--light"
          }), null, 16 /* FULL_PROPS */)
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}